// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getFirestore} from 'firebase/firestore'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCSmeUy1J5WfNlR1uGDZDSsp-NC4QcjUh4",
  authDomain: "clwc-e3b44.firebaseapp.com",
  projectId: "clwc-e3b44",
  storageBucket: "clwc-e3b44.appspot.com",
  messagingSenderId: "64795615050",
  appId: "1:64795615050:web:83be6b6d03e8a9695f6bb3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default getFirestore()
